
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/database-access",
      function () {
        return require("private-next-pages/pam/database-access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/database-access"])
      });
    }
  